export const GetFetcherScroll = (fetcher: Function) => {
  return (event) => {
    const target = event.target;
    if (target.scrollTop === target.scrollHeight - target.offsetHeight) {
      fetcher();
    }
  };
};
